import { Page } from '../Page';
import { useEffect, useState } from 'react';
import { analyticsTrack, getStandardCustomProperties } from '../webAnalytics';

const useAnalyticsPage = (page: Page, properties?: object) => {
  const [cachedProperties] = useState(properties);
  useEffect(() => {
    analyticsTrack(page, {
      ...cachedProperties,
      ...getStandardCustomProperties(),
    });
  }, [page, cachedProperties]);
};

export default useAnalyticsPage;
